import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'kexp-header',
  templateUrl: 'kexp-header.component.html',
  styleUrl: 'kexp-header.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink]
})
export class KexpHeaderComponent {}
